export const RETRY_FETCH = 'bonuses/RETRY_FETCH';
